import React, { useState, useEffect } from "react";
import { Row, Col, Form, Input, Button } from "antd";
import { useLocation, Link } from "react-router-dom";
import LeftContent from "./leftContent";
import { accountActivate, resendVerification } from "@api/auth/auth";
import { SuccessNotification, ErrorNotification } from "@components";
import logoText from "@assets/images/logo/dark-logo-text-nobg.png";

const AccountActivation = () => {
  const [email, setEmail] = useState("");
  const [expired, setExpired] = useState(false);
  const search = useLocation().search;
  const token = new URLSearchParams(search).get("token");

  useEffect(() => {
    // If there is no token, return
    if (!token) {
      // Set the expired state to true
      setExpired(true);

      return;
    }

    // Send token to the server
    accountActivate(token)
      .then((res) => {
        SuccessNotification(res.data.message);
      })
      .catch((err) => {
        const errorMessage = err.response?.data?.type?.[0]?.message;
        if (errorMessage) {
          if (errorMessage.includes("expired") || errorMessage.includes("not valid")) {
            ErrorNotification(errorMessage);
            setExpired(true);
          } else {
            ErrorNotification(errorMessage);
          }
        }
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Make the API call
    resendVerification(email)
      .then((res) => {
        SuccessNotification(res.data.message);
      })
      .catch((err) => {
        ErrorNotification(err.response.data.type[0].message);
      });
  };

  return (
    <>
      <Row
        gutter={[32, 0]}
        className="hp-authentication-page"
        style={{ overflowY: "auto", height: "100vh" }}
      >
        <LeftContent />

        <Col
          lg={8}
          md={16}
          sm={16}
          span={24}
          className="hp-py-sm-0 hp-py-md-0"
          justify="center"
        >
          <Row className="hp-h-100" align="middle" justify="center">
            <Col
              xxl={11}
              xl={15}
              lg={20}
              md={16}
              sm={24}
              className="hp-px-sm-8 hp-pt-24 hp-pb-48"
            >
              <img
                src={logoText}
                alt="logo"
                style={{
                  maxWidth: "200px",
                  height: "auto",
                  display: "block",
                  margin: "0 auto",
                }}
              />
              <h2
                className="hp-mb-sm-0"
                style={{
                  textAlign: "center",
                  fontSize: "24px",
                  lineHeight: "32px",
                  color: "rgba(0, 0, 0, 0.85)",
                }}
              >
                {expired
                  ? "Resend Verification"
                  : "Email Verified!"}
              </h2>

              {!expired && (
                <p style={{ textAlign: "center", color: "#666", marginTop: "8px" }}>
                  Thanks for confirming your email address.
                </p>
              )}

              {expired ? (
                <>
                  <Form
                    layout="vertical"
                    name="basic"
                    className="hp-mt-sm-16 hp-mt-32"
                  >
                    <Form.Item label="E-mail :">
                      <Input
                        id="validating"
                        placeholder="you@example.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Form.Item>

                    <Form.Item className="hp-mt-16">
                      <Button
                        block
                        type="primary"
                        htmlType="submit"
                        onClick={handleSubmit}
                      >
                        Resend Verification
                      </Button>
                    </Form.Item>
                  </Form>

                  <div className="login-create-acc">
                    <p>Go back to</p>

                    <Link to="/login"> Login</Link>
                  </div>
                </>
              ) : (
                <div className="hp-mt-16 hp-mb-8">
                  <Link to="/dashboard">
                    <Button block type="primary">
                      Go to Dashboard
                    </Button>
                  </Link>
                </div>
              )}

              <Col
                className="hp-other-links hp-mt-24"
                style={{
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <Link
                  to="/privacy"
                  className="hp-text-color-black-80 hp-text-color-dark-40"
                  style={{
                    marginRight: "8px",
                  }}
                >
                  Privacy Policy
                </Link>

                {/* A dot in between */}
                <span
                  className="hp-text-color-black-80 hp-text-color-dark-40"
                  style={{ margin: "0 8px", fontSize: "12px" }}
                >
                  .
                </span>

                <Link
                  to="/terms"
                  className="hp-text-color-black-80 hp-text-color-dark-40"
                >
                  Terms of Service
                </Link>
              </Col>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default AccountActivation;
